export const configMetarTafDhMetar = {
  "geo": {
    "Type": "GeoJSON",
    "url": "pri/data/AIRAC/%cycle_date%/airport/%customer%-airport.json",
    "cache_busting": true,
    "retain": true
  },
  "data": {
    "Type": "JSON",
    "Name": "METAR",
    "url": "%wrap_url%/WX_ALL_METAR_Latest/latest_auto.json",
    "cache_busting": true,
    "retain": true,
    "DataStructure": {
      "geo_position_key": "icao"
    },
    "update_interval": 60
  }
};

export const configMetarTafDhTaf = {
  "geo": {
    "Type": "GeoJSON",
    "url": "pri/data/AIRAC/%cycle_date%/airport/%customer%-airport.json",
    "cache_busting": true,
    "retain": true
  },
  "data": {
    "Type": "JSON",
    "Name": "TAF",
    "url": "%wrap_url%/WX_ALL_TAF_Latest/latest.json",
    "cache_busting": true,
    "retain": true,
    "DataStructure" : {
      "geo_position_key" : "icao"
    },
    "update_interval": 60
  }
};

export const configMetarTafLayerMetar = {
  "Name" : "METAR",
  "Renderer" : "DataJSON",
  "Attributes" : {
    "features" : [
      {
        "selector" : {
          "type" : "key_value",
          "key" : "wind_speed_kt_color",
          "value" : "violet"
        },
        "style" : {
          "default" : {
            "type" : "point",
            "point_size" : 16,
            "sensor_size" : 16,
            "line_color" : "#000000",
            "point_color" : "#723057"
          }
        }
      },
      {
        "selector" : {
          "type" : "key_value",
          "key" : "wind_speed_kt_color",
          "value" : "red_blink"
        },
        "style" : {
          "default" : {
            "type" : "point",
            "point_size" : 16,
            "sensor_size" : 16,
            "line_color" : "#000000",
            "point_color" : "#ff0000"
          }
        }
      },
      {
        "selector" : {
          "type" : "key_value",
          "key" : "wind_speed_kt_color",
          "value" : "yellow"
        },
        "style" : {
          "default" : {
            "type" : "point",
            "point_size" : 16,
            "sensor_size" : 16,
            "line_color" : "#000000",
            "point_color" : "#ffff22"
          }
        }
      },
      {
        "style" : {
          "default" : {
            "type" : "point",
            "point_size" : 16,
            "sensor_size" : 16,
            "line_color" : "#000000",
            "point_color" : "#228b22"
          }
        }
      }
    ]
  }
};

export const configMetarTafLayerTaf = {
  "Name" : "TAF",
  "Renderer" : "DataJSON",
  "Attributes" : {
    "features" : [
      {
        "style" : {
          "default" : {
            "type" : "point",
            "point_size" : 10,
            "sensor_size" : 16,
            "line_color" : "#000000",
            "point_color" : "#2288ff"
          }
        }
      }
    ]
  }
};
